/* ============================================================
   Quiz Aste su Misura — Fotorecord (percorso assistito)
   prefix: qasm-
   Percorso a 5 passi (21/09/2026):
     1 Opera e misure → 2 Cornice → 3 Protezione e retro → 4 Finiture → 5 Riepilogo
     Dal passo 2 «Solo la cornice» porta dritto al riepilogo.
   Stesso motore del configuratore: FR.corniceNetto / getFascia / makeMk /
   imballoNetto (configuratore-pricing.js), FR.core.pickBucket / addToCart
   (configuratore-core.js), regole FR.retroConsentito / FR.vincoloCrilex.
   Le properties di carrello sono le stesse di ConfiguratoreAste (lettore:
   core/fotorecord/ordini_articoli.py).
   Base dichiarata = SOLA cornice + attaccaglie (decisione operatore 21/09/2026):
   fronte e retro nascono «Nessuno» e si scelgono al passo 3. Nessun prezzo cambia
   per il solo fatto di entrare in un passo.
   ============================================================ */

(function () {
  'use strict';

  /* ── COSTANTI ── */
  /* Le soglie/misure di prodotto NON si scrivono qui: si leggono da PRICING_SSOT, il
     blocco generato da price_logic (configuratore-pricing.js, caricato prima di questo
     file). IVA e soglia «solo su preventivo» comprese: fino al 21/09/2026 il quiz
     portava un PRICING locale con SOGLIA_PREVENTIVO 75 mentre il motore decideva a 105,
     e il cliente leggeva una soglia sbagliata. */
  var FR  = window.FOTORECORD || {};
  /* «FRAS0055 - Cornice Sagomata Blu Poro Aperto» (core.nomeBreveCliente, 21/09/2026). */
  function nb(rec) { return (rec && FR.core && FR.core.nomeBreveCliente) ? FR.core.nomeBreveCliente(rec) : (rec && rec.nome ? String(rec.nome).split('|')[0].trim() : ''); }
  var _SS = FR.PRICING_SSOT || {};
  var TOTAL_STEPS           = 5;
  var STEP_NAMES            = { 1: 'Opera e misure', 2: 'Cornice', 3: 'Protezione e retro', 4: 'Finiture', 5: 'Riepilogo' };
  var BATTENTE_ALTO_MM      = _SS.PP_LEGNO_MIN_BATTENTE_MM;
  var BATTENTE_MIN_TELA_MM  = _SS.BATTENTE_MIN_TELA_MM;
  var NESSUNO_SKU           = '__nessuno';
  var ARTWORK_KEY           = 'qasm_artwork_dataurl';  /* handoff foto → configuratore (anteprima ridotta) */
  var STATE_KEY             = 'qasm_stato';            /* scelte non personali, per tornare indietro senza perderle */
  var STATE_VERSION         = 2;
  var ARTWORK_MAX_DIM       = 1400;                    /* downscale per preview + sessionStorage */
  var ARTWORK_MAX_BYTES     = 20 * 1024 * 1024;        /* come ConfiguratoreBase._onArtworkFile */
  var CVS_W = 400, CVS_H = 400, CVS_PAD = 36;
  var PASS_LEGNO_COLOR      = '#C8A96E';
  var PASS_CARTONE_COLOR    = '#F0ECE0';
  var DEFAULT_BASE          = 20;
  var DEFAULT_ALTEZZA       = 30;
  /* minimo per lato quando il profilo non dichiara dim_min: lo stesso 9 di
     ConfiguratoreAste.validateConfig */
  var DIM_MIN_CM            = 9;
  var GALLERY_PAGE          = 48;                      /* card per «Mostra altre cornici» */

  var PRESETS = [
    { label: '10×15',  base: 10,   altezza: 15   },
    { label: '13×18',  base: 13,   altezza: 18   },
    { label: '15×20',  base: 15,   altezza: 20   },
    { label: '20×20',  base: 20,   altezza: 20   },
    { label: '20×30',  base: 20,   altezza: 30   },
    { label: 'A4',     base: 21,   altezza: 29.7 },
    { label: '30×40',  base: 30,   altezza: 40   },
    { label: '40×50',  base: 40,   altezza: 50   },
    { label: 'A3',     base: 29.7, altezza: 42   },
    { label: '50×70',  base: 50,   altezza: 70   },
  ];

  /* ── STATE ── */
  var state = {
    currentStep:     1,
    base:            null,
    altezza:         null,
    profiloSku:      null,
    profilo:         null,
    fronteSku:       null,   /* null = «Nessuno»: la base e' la sola cornice */
    retroSku:        null,
    passCartoneSku:  null,
    passCartone:     null,
    passCartoneLargh: null,  /* cm — da _passCartoneLarghDefault, mai un numero qui */
    passLegnoSku:    null,
    passLegno:       null,
    stampaTipo:      null,   /* null | 'foto' | 'tela' */
    stampa:          null,
    qty:             1,
    filters:         { stile: '', colore: '', finitura: '', battente: '' },
    visited:         { 1: true },
    galleryShown:    GALLERY_PAGE,
  };

  var _currentBucket = null;
  var profiliAll = [];
  var D          = null;

  /* ── CANVAS — preview con immagini reali (9-slice, allineato al configuratore) ── */
  var _artworkImg         = null; var _artworkDataUrl     = '';
  var _artworkFile        = null;   /* il file originale: master di stampa, come nei configuratori */
  var _frameImg           = null; var _frameImgUrl        = '';
  var _passLegnoImg       = null; var _passLegnoImgUrl    = '';
  var _passCartoneImg     = null; var _passCartoneImgUrl  = '';
  var _passCartoneTile    = null; var _passCartoneTileKey = '';

  function $(id) { return document.getElementById(id); }

  /* ══════════════════════════════════════
     INIT
  ══════════════════════════════════════ */
  function init() {
    D = window.QASM_DATA;
    if (!D) { console.error('[QASM] QASM_DATA non disponibile'); return; }

    /* Profili proposti come acquistabili: quelli del configuratore aste E disponibili.
       Un profilo esaurito (disponibile:false da db_metro_lineare) non entra nel percorso
       assistito: nel configuratore completo resta visibile col badge «Esaurito». */
    var raw = window.ASTE_CORNICI_FULL || [];
    profiliAll = raw.filter(function (p) {
      return (p.configuratore || '').indexOf('aste_su_misura') !== -1 && p.disponibile !== false;
    });
    if (!profiliAll.length) console.warn('[QASM] Nessun profilo aste_su_misura disponibile');

    state.base    = DEFAULT_BASE;
    state.altezza = DEFAULT_ALTEZZA;

    _initStep1();
    _initStep2();
    _initStep3();
    _initStep4();
    _initStep5();
    _initCanvas();
    _initBar();
    _initStepper();
    _initPreventivoModal();
    _checkSuccess();
    $('qasm-back-btn').addEventListener('click', _prevStep);

    /* ripristina foto e scelte della sessione (es. back dal configuratore, reload) */
    try {
      var saved = sessionStorage.getItem(ARTWORK_KEY);
      if (saved) _setArtworkFromDataURL(saved);
    } catch (e) {}
    var restoredStep = _restoreState();

    _syncStep1UI();
    _goToStep(restoredStep || 1, true);
  }

  /* ══════════════════════════════════════
     NAVIGAZIONE
  ══════════════════════════════════════ */
  function _canEnter(n) {
    if (n <= 1) return true;
    if (!_dimsValide().ok) return false;
    if (n === 2) return true;
    return !!state.profilo;
  }

  function _goToStep(n, silent) {
    /* passo non raggiungibile: si torna al primo passo che manca (misure, poi cornice) */
    if (!_canEnter(n)) n = !_dimsValide().ok ? 1 : Math.min(n, 2);
    state.currentStep = n;
    state.visited[n] = true;
    document.querySelectorAll('.qasm-step').forEach(function (el) {
      var num = parseInt(el.id.replace('qasm-step-', ''), 10);
      el.classList.toggle('qasm-step--active', num === n);
    });
    $('qasm-back-btn').hidden = (n === 1);
    var counter = $('qasm-step-counter');
    if (counter) counter.textContent = 'Passo ' + n + ' di ' + TOTAL_STEPS + ' — ' + STEP_NAMES[n];
    _renderStepper();
    _onStepEnter(n);
    _saveState();
    if (!silent) _scrollToWizard();
  }

  function _nextStep() { if (state.currentStep < TOTAL_STEPS) _goToStep(state.currentStep + 1); }
  function _prevStep() { if (state.currentStep > 1) _goToStep(state.currentStep - 1); }

  /* Il percorso cambia schermata ma la pagina puo' essere scrollata a fondo (gallery
     lunga, tastiera): il titolo del passo nuovo torna in vista. */
  function _scrollToWizard() {
    var col = document.querySelector('.qasm-wizard-col');
    if (!col) return;
    var r = col.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.6) {
      var header = document.querySelector('.section-header');
      var off = (header && getComputedStyle(header).position === 'sticky') ? header.offsetHeight : 0;
      window.scrollTo({ top: window.scrollY + r.top - off - 12, behavior: 'smooth' });
    }
  }

  function _onStepEnter(n) {
    if (n === 1) _syncStep1UI();
    if (n === 2) _enterStep2();
    if (n === 3) _enterStep3();
    if (n === 4) _enterStep4();
    if (n === 5) _renderRiepilogo();
    _updatePrice();
  }

  function _initStepper() {
    var ol = $('qasm-stepper');
    if (!ol) return;
    ol.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-step]');
      if (!btn || btn.disabled) return;
      _goToStep(parseInt(btn.dataset.step, 10));
    });
  }

  function _renderStepper() {
    var ol = $('qasm-stepper');
    if (!ol) return;
    ol.querySelectorAll('button[data-step]').forEach(function (btn) {
      var n = parseInt(btn.dataset.step, 10);
      var reachable = _canEnter(n) && (state.visited[n] || n === state.currentStep);
      btn.disabled = !reachable;
      btn.classList.toggle('is-current', n === state.currentStep);
      btn.classList.toggle('is-done', n < state.currentStep && !!state.visited[n]);
      if (n === state.currentStep) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
    });
  }

  /* ══════════════════════════════════════
     PASSO 1 — OPERA E MISURE
  ══════════════════════════════════════ */
  function _dimsValide() {
    var b = state.base, a = state.altezza;
    if (!b || !a) return { ok: false, msg: 'Inserisci base e altezza in centimetri.' };
    var minB = (state.profilo && state.profilo.dimMinBase > 0) ? state.profilo.dimMinBase : DIM_MIN_CM;
    var minA = (state.profilo && state.profilo.dimMinAlt  > 0) ? state.profilo.dimMinAlt  : DIM_MIN_CM;
    if (b < minB || a < minA) return { ok: false, msg: 'Misure minime: ' + minB + ' × ' + minA + ' cm.' };
    return { ok: true, msg: '' };
  }

  function _initStep1() {
    var grid   = $('qasm-presets');
    var inBase = $('qasm-dim-base');
    var inAlt  = $('qasm-dim-alt');

    PRESETS.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qasm-preset-btn';
      btn.textContent = p.label;
      btn.dataset.base = p.base; btn.dataset.altezza = p.altezza;
      btn.addEventListener('click', function () {
        state.base    = p.base;
        state.altezza = p.altezza;
        inBase.value  = p.base;
        inAlt.value   = p.altezza;
        _onDimsChanged();
      });
      grid.appendChild(btn);
    });

    function _onInput() {
      state.base    = parseFloat(inBase.value) || null;
      state.altezza = parseFloat(inAlt.value)  || null;
      _onDimsChanged();
    }
    inBase.addEventListener('input', _onInput);
    inAlt.addEventListener('input', _onInput);

    /* cosa va nella cornice */
    var stampe  = D.stampe || [];
    var hasFoto = stampe.some(function (s) { return s.tipo === 'foto'; });
    var hasTela = stampe.some(function (s) { return s.tipo === 'tela'; });
    var opts = [{ tipo: null, label: 'Ho già la stampa o l’opera', sub: 'Porto o spedisco io ciò che va incorniciato' }];
    if (hasFoto) opts.push({ tipo: 'foto', label: 'Stampate voi la mia foto', sub: 'Carta fotografica professionale, stampata da noi' });
    if (hasTela) opts.push({ tipo: 'tela', label: 'Stampa su tela', sub: 'Tela canvas su telaio, per cornici con battente alto' });
    var sgrid = $('qasm-stampa-grid');
    opts.forEach(function (o) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'qasm-stampa-card';
      card.dataset.tipo = o.tipo || '';
      card.setAttribute('role', 'radio');
      card.innerHTML = '<strong>' + _esc(o.label) + '</strong><span>' + _esc(o.sub) + '</span>';
      card.addEventListener('click', function () {
        state.stampaTipo = o.tipo;
        state.stampa     = _resolveStampa(o.tipo);
        _onStampaChanged();
      });
      sgrid.appendChild(card);
    });

    _initDropzone();
    $('qasm-confirm-1').addEventListener('click', function () {
      var v = _dimsValide();
      var err = $('qasm-err-dim');
      if (!v.ok) { err.textContent = v.msg; err.hidden = false; return; }
      err.hidden = true;
      if (state.stampaTipo && !_artworkFile) {
        var ef = $('qasm-err-foto');
        ef.textContent = _artworkImg
          ? 'La foto va ricaricata: per la stampa serve il file originale, non l’anteprima.'
          : 'Hai scelto la stampa: carica la foto da stampare (JPG o PNG, fino a 20 MB).';
        ef.hidden = false;
        $('qasm-dropzone').focus();
        return;
      }
      $('qasm-err-foto').hidden = true;
      _nextStep();
    });
  }

  function _onDimsChanged() {
    $('qasm-err-dim').hidden = true;
    state.stampa = _resolveStampa(state.stampaTipo);   /* small/pro dipende dal formato */
    _syncStep1UI();
    _updatePrice();
    _drawCanvas();
    _saveState();
  }

  function _onStampaChanged() {
    /* tela: serve un battente alto — una cornice gia' scelta con battente basso non
       si tiene in silenzio: si toglie e lo si dice nel passo 2 */
    if (state.stampaTipo === 'tela' && state.profilo && !_profiloOkPerTela(state.profilo)) {
      state.profiloSku = null; state.profilo = null;
      state.avvisoProfilo = 'La cornice che avevi scelto ha un battente basso: la stampa su tela richiede un battente alto. Qui sotto trovi solo cornici adatte.';
      _loadFrameImg('');
    }
    state.stampa = _resolveStampa(state.stampaTipo);
    $('qasm-err-foto').hidden = true;
    _syncStep1UI();
    _updatePrice();
    _saveState();
  }

  function _profiloOkPerTela(p) {
    var b = parseFloat(p.altezza_battente_mm) || 0;
    return !(b > 0 && b < BATTENTE_MIN_TELA_MM);
  }

  /* Riflette lo stato nei controlli del passo 1 (preset attivo, card stampa, foto). */
  function _syncStep1UI() {
    var grid = $('qasm-presets');
    grid.querySelectorAll('.qasm-preset-btn').forEach(function (b) {
      b.classList.toggle('active', parseFloat(b.dataset.base) === state.base && parseFloat(b.dataset.altezza) === state.altezza);
    });
    var inBase = $('qasm-dim-base'), inAlt = $('qasm-dim-alt');
    if (document.activeElement !== inBase && state.base)    inBase.value = state.base;
    if (document.activeElement !== inAlt  && state.altezza) inAlt.value  = state.altezza;

    /* nota sulla fascia: oltre la soglia il prezzo e' su preventivo */
    var hint = $('qasm-hint-dim');
    var lmax = Math.max(state.base || 0, state.altezza || 0);
    if (lmax > _SS.SOGLIA_SOLO_PREVENTIVO_CM) {
      hint.textContent = 'Oltre ' + _SS.SOGLIA_SOLO_PREVENTIVO_CM + ' cm di lato la cornice si ordina su preventivo: completa comunque il percorso e ti rispondiamo via email.';
    } else if (lmax > _SS.SOGLIA_SUPPLEMENTO_CM) {
      hint.textContent = 'Formato grande: il supplemento imballo è già compreso nel prezzo che vedi.';
    } else {
      hint.textContent = '';
    }

    document.querySelectorAll('#qasm-stampa-grid .qasm-stampa-card').forEach(function (c) {
      var sel = (c.dataset.tipo || null) === state.stampaTipo;
      c.classList.toggle('active', sel);
      c.setAttribute('aria-checked', sel ? 'true' : 'false');
    });
    var shint = $('qasm-stampa-hint');
    if (state.stampaTipo === 'tela') {
      shint.textContent = 'Per la tela servono cornici con battente alto (almeno ' + BATTENTE_MIN_TELA_MM + ' mm): nel passo successivo vedrai solo quelle.';
      shint.hidden = false;
    } else { shint.hidden = true; }

    var title = $('qasm-foto-title'), fhint = $('qasm-foto-hint');
    if (state.stampaTipo) {
      title.innerHTML = 'La foto da stampare <span class="qasm-required">obbligatoria</span>';
      fhint.textContent = 'Il file originale è il master di stampa: JPG o PNG, fino a 20 MB. Oltre, invialo a info@fotorecord.it dopo l’ordine.';
    } else {
      title.innerHTML = 'La tua foto <span class="qasm-optional">facoltativa</span>';
      fhint.textContent = 'Caricala per vederla dentro la cornice mentre scegli.';
    }
    _reflectArtworkUI(!!_artworkImg);
  }

  function _resolveStampa(tipo) {
    if (!tipo) return null;
    var list = (D.stampe || []).filter(function (s) { return s.tipo === tipo; });
    if (!list.length) return null;
    if (tipo === 'tela') return list[0];
    /* foto: small se entrambi i lati rientrano nei max, altrimenti pro */
    var small = list.find(function (s) { return (s.maxBase || 999) < 999; });
    var pro   = list.find(function (s) { return (s.maxBase || 999) >= 999; }) || list[list.length - 1];
    if (!small) return pro;
    var b = state.base, a = state.altezza;
    if (!b || !a) return pro;
    var isSmall = (b <= small.maxBase && a <= small.maxAlt) ||
                  (a <= small.maxBase && b <= small.maxAlt);
    return isSmall ? small : pro;
  }

  /* ── dropzone foto (passo 1) ── */
  function _initDropzone() {
    var dz     = $('qasm-dropzone');
    var input  = $('qasm-foto-input');
    var change = $('qasm-foto-change');
    var remove = $('qasm-foto-remove');
    if (!dz) return;
    function pick() { if (input) input.click(); }
    dz.addEventListener('click', function (e) {
      if (e.target.closest('#qasm-dropzone-filled')) return;
      pick();
    });
    dz.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
    dz.addEventListener('dragover',  function (e) { e.preventDefault(); dz.classList.add('dragover'); });
    dz.addEventListener('dragleave', function ()  { dz.classList.remove('dragover'); });
    dz.addEventListener('drop', function (e) {
      e.preventDefault(); dz.classList.remove('dragover');
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) _setArtworkFromFile(file);
    });
    if (change) change.addEventListener('click', function (e) { e.stopPropagation(); pick(); });
    if (remove) remove.addEventListener('click', function (e) { e.stopPropagation(); _clearArtwork(); });
  }

  /* ══════════════════════════════════════
     PASSO 2 — CORNICE (filtri + gallery con prezzo)
  ══════════════════════════════════════ */
  function _initStep2() {
    $('qasm-confirm-2').addEventListener('click', function () {
      if (!state.profilo) { $('qasm-err-2').hidden = false; return; }
      $('qasm-err-2').hidden = true;
      _goToStep(3);
    });
    $('qasm-base-2').addEventListener('click', function () {
      if (!state.profilo) { $('qasm-err-2').hidden = false; return; }
      $('qasm-err-2').hidden = true;
      /* solo cornice: i passi 3 e 4 restano raggiungibili dal riepilogo (Modifica) */
      state.visited[3] = true; state.visited[4] = true;
      _goToStep(5);
    });
    $('qasm-gallery-more').addEventListener('click', function () {
      state.galleryShown += GALLERY_PAGE;
      _renderGallery(true);
    });
    var grid = $('qasm-gallery');
    grid.addEventListener('click', function (e) {
      var item = e.target.closest('.qasm-card');
      if (item) _selectProfilo(item.dataset.sku);
    });
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var item = e.target.closest('.qasm-card');
      if (item) { e.preventDefault(); _selectProfilo(item.dataset.sku); }
    });
  }

  function _enterStep2() {
    _buildFilterPills();
    var sub = $('qasm-step2-sub');
    var extra = _inclusiExtra();
    sub.textContent = extra.length
      ? 'Il prezzo su ogni cornice è quello della tua configurazione (' + extra.join(', ') + ') per le misure inserite.'
      : 'Il prezzo su ogni cornice è quello della sola cornice per le tue misure, attaccaglie incluse.';
    if (state.avvisoProfilo) {
      var err = $('qasm-err-2');
      err.textContent = state.avvisoProfilo; err.hidden = false;
      state.avvisoProfilo = null;
    } else {
      $('qasm-err-2').textContent = 'Scegli una cornice per continuare.';
      $('qasm-err-2').hidden = true;
    }
    _renderGallery();
    _showProfiloSel();
  }

  /* Pool di profili compatibili con la scelta di stampa (tela → battente alto). */
  function _profiliCompatibili() {
    if (state.stampaTipo !== 'tela') return profiliAll;
    return profiliAll.filter(_profiloOkPerTela);
  }

  function _profiliFiltrati() {
    var list = _profiliCompatibili();
    var f = state.filters;
    if (f.stile)    list = list.filter(function (p) { return p.stile    === f.stile;    });
    if (f.colore)   list = list.filter(function (p) { return p.colore   === f.colore;   });
    if (f.finitura) list = list.filter(function (p) { return p.finitura === f.finitura; });
    if (f.battente) {
      var wantAlto = f.battente === 'alto';
      list = list.filter(function (p) {
        var b = parseFloat(p.altezza_battente_mm) || 0;
        return wantAlto ? b >= BATTENTE_ALTO_MM : b < BATTENTE_ALTO_MM;
      });
    }
    return list;
  }

  function _buildFilterPills() {
    var pool = _profiliCompatibili();
    function values(key) {
      var seen = {}, out = [];
      pool.forEach(function (p) { var v = p[key]; if (v && !seen[v]) { seen[v] = true; out.push(v); } });
      return out.sort().map(function (v) { return { value: v, label: v }; });
    }
    _fillPillGroup('qasm-pills-stile',    values('stile'),    'stile');
    _fillPillGroup('qasm-pills-colore',   values('colore'),   'colore');
    _fillPillGroup('qasm-pills-finitura', values('finitura'), 'finitura');
    _fillPillGroup('qasm-pills-battente', [
      { value: 'basso', label: 'Basso (< ' + BATTENTE_ALTO_MM + ' mm)' },
      { value: 'alto',  label: 'Alto (≥ ' + BATTENTE_ALTO_MM + ' mm)' },
    ], 'battente');
    var tech = $('qasm-filter-tech');
    if (tech && state.filters.battente) tech.open = true;
  }

  function _fillPillGroup(containerId, items, filterKey) {
    var container = $(containerId);
    if (!container) return;
    container.innerHTML = '';
    function _mkPill(label, value) {
      var pill = document.createElement('button');
      pill.type = 'button';
      var isActive = (value === '' && !state.filters[filterKey]) ||
                     (value !== '' && value === state.filters[filterKey]);
      pill.className = 'qasm-pill' + (isActive ? ' active' : '') +
        (filterKey === 'colore' && value !== '' ? ' qasm-pill--colore' : '');
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (filterKey === 'colore' && value !== '') {
        var sw = document.createElement('span');
        sw.className = 'qasm-pill-swatch';
        sw.style.background = _colorHex(value);
        pill.appendChild(sw);
        pill.appendChild(document.createTextNode(label));
      } else {
        pill.textContent = label;
      }
      pill.addEventListener('click', function () {
        state.filters[filterKey] = value;
        state.galleryShown = GALLERY_PAGE;
        _buildFilterPills();
        _renderGallery();
        _saveState();
      });
      return pill;
    }
    container.appendChild(_mkPill('Tutti', ''));
    items.forEach(function (it) { container.appendChild(_mkPill(it.label, it.value)); });
  }

  function _colorHex(colorName) {
    return FR.coloreHex ? FR.coloreHex(colorName, '#c8a96e') : '#c8a96e';
  }

  /* ── nomi per il cliente ──
     Il campo `nome` porta il titolo Shopify con il suffisso «| id semantico», chiave
     interna dei CSV: sulla card si mostrano colore, finitura, larghezza e il codice
     pubblico (FR.core.pubblico), il titolo pulito resta nel tooltip. */
  function _titoloPulito(p) { return String((p && p.nome) || '').split(' | ')[0].trim(); }
  function _cap(s) { s = String(s || ''); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }
  function _codicePubblico(p) {
    if (!p || !p.sku) return '';
    var core = FR.core || {};
    var id = core.toIdDb ? core.toIdDb(p.sku) : p.sku;
    return core.pubblico ? core.pubblico(id) : String(id).toUpperCase();
  }
  function _nomeProfilo(p) {
    var parts = [p.colore, p.finitura].filter(Boolean).map(_cap);
    return parts.join(' · ') || _titoloPulito(p) || _codicePubblico(p);
  }
  function _larghezzaProfilo(p) {
    var mm = parseFloat(p.larghezza_sezione_mm) || 0;
    return mm ? 'Larghezza ' + (Math.round(mm * 10) / 10) + ' mm' : '';
  }
  function _profiloCodice(p) { return (p && p.sku) ? p.sku : '—'; }

  function _renderGallery(append) {
    var grid = $('qasm-gallery');
    var cnt  = $('qasm-gallery-count');
    var more = $('qasm-gallery-more');
    var list = _profiliFiltrati();
    var attivi = Object.keys(state.filters).filter(function (k) { return state.filters[k]; }).length;

    cnt.textContent = list.length + (list.length === 1 ? ' cornice' : ' cornici') +
      (attivi ? ' con questi filtri' : ' disponibili');

    if (!list.length) {
      grid.innerHTML =
        '<div class="qasm-gallery-empty">' +
          '<p>Nessuna cornice corrisponde a tutti questi filtri insieme.</p>' +
          '<button type="button" class="qasm-reset-filters" id="qasm-reset-filters">Togli i filtri</button>' +
        '</div>';
      $('qasm-reset-filters').addEventListener('click', function () {
        state.filters = { stile: '', colore: '', finitura: '', battente: '' };
        state.galleryShown = GALLERY_PAGE;
        _buildFilterPills();
        _renderGallery();
        _saveState();
      });
      more.hidden = true;
      return;
    }

    var shown = list.slice(0, state.galleryShown);
    var html = shown.map(function (p) {
      var sel = p.sku === state.profiloSku;
      var prezzo = _prezzoVenditaCon({ profilo: p });
      var res = _calcPrezzoCon({ profilo: p });
      var prezzoTxt = prezzo != null ? FR.fmtEuro(prezzo)
                    : (res && res.soloPreventivo ? 'Su preventivo' : '');
      var img = p.immagine_url
        ? '<img src="' + _esc(FR.core.thumbUrl ? FR.core.thumbUrl(p.immagine_url, 400) : p.immagine_url) + '" alt="" loading="lazy">'
        : '<span class="qasm-card-ph" style="background:' + _colorHex(p.colore) + '"></span>';
      return '<div class="qasm-card' + (sel ? ' selected' : '') + '" role="option" tabindex="0" aria-selected="' + (sel ? 'true' : 'false') + '" ' +
             'data-sku="' + _esc(p.sku) + '" title="' + _esc(_titoloPulito(p)) + '">' +
               '<span class="qasm-card-img">' + img + '</span>' +
               '<span class="qasm-card-body">' +
                 '<strong class="qasm-card-name">' + _esc(_nomeProfilo(p)) + '</strong>' +
                 '<span class="qasm-card-meta">' + _esc(_larghezzaProfilo(p)) + '</span>' +
                 '<span class="qasm-card-foot"><span class="qasm-card-code">' + _esc(_codicePubblico(p)) + '</span>' +
                 (prezzoTxt ? '<span class="qasm-card-price">' + _esc(prezzoTxt) + '</span>' : '') + '</span>' +
               '</span>' +
             '</div>';
    }).join('');
    grid.innerHTML = html;
    var restano = list.length - shown.length;
    more.hidden = restano <= 0;
    if (restano > 0) more.textContent = 'Mostra altre cornici (' + restano + ')';
    if (append) {
      /* focus sulla prima card appena aggiunta, cosi' da tastiera si riparte da li' */
      var first = grid.children[Math.max(0, state.galleryShown - GALLERY_PAGE)];
      if (first && first.focus) first.focus();
    }
  }

  function _selectProfilo(sku) {
    var profilo = profiliAll.find(function (p) { return p.sku === sku; });
    if (!profilo) return;
    state.profiloSku = sku;
    state.profilo    = profilo;
    _onProfiloChange();
    $('qasm-err-2').hidden = true;
    document.querySelectorAll('#qasm-gallery .qasm-card').forEach(function (el) {
      var on = el.dataset.sku === sku;
      el.classList.toggle('selected', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    _showProfiloSel();
    _updatePrice();
    _loadFrameImg(profilo.immagine_url || '');
    _drawCanvas();
    _saveState();
    /* nessun avanzamento automatico: si confrontano le cornici e si continua col bottone */
    var sel = $('qasm-profilo-sel');
    if (sel && window.innerWidth < 900) sel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* Reset selezioni invalide se cambio profilo a battente basso */
  function _onProfiloChange() {
    if (!state.profilo) return;
    var battMm = parseFloat(state.profilo.altezza_battente_mm) || 0;
    if (battMm > 0 && battMm < BATTENTE_ALTO_MM && state.passLegnoSku) {
      state.passLegnoSku = null; state.passLegno = null;
      _loadPassLegnoImg('');
    }
  }

  function _showProfiloSel() {
    var sel = $('qasm-profilo-sel');
    var p = state.profilo;
    if (!p) { sel.classList.remove('visible'); return; }
    var img = $('qasm-profilo-img');
    if (p.immagine_url) { img.src = FR.core.thumbUrl ? FR.core.thumbUrl(p.immagine_url, 200) : p.immagine_url; img.style.display = 'block'; }
    else { img.style.display = 'none'; }
    $('qasm-profilo-nome').textContent = _nomeProfilo(p) + ' · ' + _codicePubblico(p);
    $('qasm-profilo-sub').textContent  = [_larghezzaProfilo(p), _titoloPulito(p)].filter(Boolean).join(' · ');
    var prezzo = _prezzoVendita();
    $('qasm-profilo-price').textContent = prezzo != null ? FR.fmtEuro(prezzo) : '';
    sel.classList.add('visible');
  }

  /* ══════════════════════════════════════
     PASSO 3 — PROTEZIONE E RETRO (opzioni con differenza di prezzo)
  ══════════════════════════════════════ */
  function _initStep3() {
    $('qasm-fronte-list').addEventListener('click', function (e) {
      var opt = e.target.closest('.qasm-opt');
      if (!opt || opt.classList.contains('is-disabled')) return;
      state.fronteSku = opt.dataset.sku === NESSUNO_SKU ? null : opt.dataset.sku;
      _renderOpzioni(); _updatePrice(); _saveState();
    });
    $('qasm-retro-list').addEventListener('click', function (e) {
      var opt = e.target.closest('.qasm-opt');
      if (!opt || opt.classList.contains('is-disabled')) return;
      state.retroSku = opt.dataset.sku === NESSUNO_SKU ? null : opt.dataset.sku;
      _renderOpzioni(); _updatePrice(); _saveState();
    });
    $('qasm-confirm-3').addEventListener('click', function () {
      var errs = _validazione().filter(function (m) { return m.passo === 3; });
      var err = $('qasm-err-fronte');
      if (errs.length) { err.textContent = errs[0].testo; err.hidden = false; return; }
      err.hidden = true;
      _goToStep(4);
    });
  }

  function _enterStep3() {
    _renderOpzioni();
    _renderAttaccaglie();
  }

  function _fronteSel() { return (D.fronti || []).find(function (x) { return x.sku === state.fronteSku; }) || null; }
  function _retroSel()  { return (D.retri  || []).find(function (x) { return x.sku === state.retroSku;  }) || null; }
  function _ppcLargh()  { return state.passCartone ? (state.passCartoneLargh || 0) : 0; }
  function _pplMm()     { return state.passLegno ? (state.passLegno.larghezzaMm || 0) : 0; }

  function _renderOpzioni() {
    var fl = $('qasm-fronte-list'), rl = $('qasm-retro-list');
    var opzF = [{ sku: NESSUNO_SKU, nome: 'Nessuna protezione', sub: 'Solo cornice: l’opera resta a vista' }]
      .concat((D.fronti || []).map(function (f) {
        var motivo = FR.vincoloCrilex(f, state.base, state.altezza);
        return { sku: f.sku, nome: nb(f), sub: f.descrizioneBreve || '', disabled: !!motivo, motivo: motivo };
      }));
    var opzR = [{ sku: NESSUNO_SKU, nome: 'Nessun retro', sub: 'Solo cornice: chiusura a cura tua' }]
      .concat((D.retri || []).map(function (r) {
        var ok = FR.retroConsentito(r, state.base, state.altezza, _ppcLargh(), _pplMm());
        return { sku: r.sku, nome: nb(r), sub: r.descrizioneBreve || '', disabled: !ok,
                 motivo: ok ? '' : 'Regge formati finiti fino a ' + r.maxBase + ' × ' + r.maxAltezza + ' cm (opera + passepartout)' };
      }));
    fl.innerHTML = opzF.map(function (o) { return _optHtml(o, state.fronteSku, 'fronteSku'); }).join('');
    rl.innerHTML = opzR.map(function (o) { return _optHtml(o, state.retroSku,  'retroSku');  }).join('');
    var errs = _validazione().filter(function (m) { return m.passo === 3; });
    var err = $('qasm-err-fronte');
    if (errs.length) { err.textContent = errs[0].testo; err.hidden = false; } else { err.hidden = true; }
  }

  function _optHtml(o, curSku, key) {
    var cur = (curSku || NESSUNO_SKU) === o.sku;
    var over = {}; over[key] = o.sku === NESSUNO_SKU ? null : o.sku;
    var delta = cur ? 0 : _deltaEuro(over);
    var badge;
    if (cur) badge = 'Selezionato';
    else if (o.disabled || delta == null) badge = '';
    else if (Math.abs(delta) < 0.005) badge = 'Stesso prezzo';
    else badge = (delta > 0 ? '+ ' : '− ') + FR.fmtEuro(Math.abs(delta));
    return '<button type="button" class="qasm-opt' + (cur ? ' is-selected' : '') + (o.disabled ? ' is-disabled' : '') + '" ' +
           'role="radio" aria-checked="' + (cur ? 'true' : 'false') + '" data-sku="' + _esc(o.sku) + '"' + (o.disabled ? ' aria-disabled="true"' : '') + '>' +
             '<span class="qasm-opt-radio" aria-hidden="true"></span>' +
             '<span class="qasm-opt-text"><strong>' + _esc(o.nome) + '</strong>' +
               (o.sub ? '<span>' + _esc(o.sub) + '</span>' : '') +
               (o.disabled && o.motivo ? '<span class="qasm-opt-motivo">' + _esc(o.motivo) + '</span>' : '') +
             '</span>' +
             '<span class="qasm-opt-delta' + (cur ? ' is-current' : '') + '">' + _esc(badge) + '</span>' +
           '</button>';
  }

  function _renderAttaccaglie() {
    var box = $('qasm-attaccaglie-info');
    if (!box) return;
    var n = _nAttaccaglie();
    box.innerHTML = '<strong>' + n + ' attaccagli' + (n === 1 ? 'a' : 'e') + '</strong>' +
      ' inclus' + (n === 1 ? 'a' : 'e') + ' nel prezzo, calcolat' + (n === 1 ? 'a' : 'e') +
      ' sul formato finito: la cornice arriva pronta da appendere.';
  }

  /* Soglia e conteggi da PRICING_SSOT (origine: price_logic.get_hangers_count) e misura
     sul BATTENTE, come il configuratore e price_engine. */
  function _nAttaccaglie() {
    var P  = _SS;
    if (!state.base || !state.altezza) return P.N_ATTACCAGLIE_GRANDE || 2;
    var batt = FR.dimsBattente
      ? FR.dimsBattente(state.base, state.altezza, _ppcLargh(), _pplMm())
      : { b: state.base, h: state.altezza };
    var soglia = P.SOGLIA_ATTACCAGLIE_CM;
    return (batt.b > soglia || batt.h > soglia)
      ? (P.N_ATTACCAGLIE_GRANDE || 2)
      : (P.N_ATTACCAGLIE_STD || 1);
  }

  /* ══════════════════════════════════════
     PASSO 4 — FINITURE (passepartout cartone + legno)
  ══════════════════════════════════════ */
  function _initStep4() {
    var gc = $('qasm-gallery-cartone');
    var gl = $('qasm-gallery-legno');
    var range = $('qasm-pc-range');
    var pcVal = $('qasm-pc-val');

    function onCartone(target) {
      var item = target.closest('[data-pass-cartone]');
      if (!item) return;
      var sku = item.dataset.passCartone;
      if (sku === NESSUNO_SKU) {
        state.passCartoneSku = null; state.passCartone = null;
        _loadPassCartoneImg('');
      } else {
        var p = (D.passCartone || []).find(function (x) { return x.sku === sku; });
        if (!p) return;
        state.passCartoneSku = sku; state.passCartone = p;
        _loadPassCartoneImg(p.imgUrl || '');
      }
      _renderGalleryCartone();
      _updatePrice(); _drawCanvas(); _saveState();
    }
    gc.addEventListener('click', function (e) { onCartone(e.target); });
    gc.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCartone(e.target); } });

    function onLegno(target) {
      var section = $('qasm-pass-legno-section');
      if (section && section.classList.contains('qasm-pass-legno-wrap--locked')) return;
      var item = target.closest('[data-pass-legno]');
      if (!item) return;
      var sku = item.dataset.passLegno;
      if (sku === NESSUNO_SKU) {
        state.passLegnoSku = null; state.passLegno = null;
        _loadPassLegnoImg('');
      } else {
        var p = (D.passLegno || []).find(function (x) { return x.sku === sku; });
        if (!p) return;
        state.passLegnoSku = sku; state.passLegno = p;
        _loadPassLegnoImg(p.imgUrl || '');
      }
      _renderGalleryLegno();
      _updatePrice(); _drawCanvas(); _saveState();
    }
    gl.addEventListener('click', function (e) { onLegno(e.target); });
    gl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onLegno(e.target); } });

    /* tetto del bordo dalla SSOT (price_logic.PASSEPARTOUT_CARTONE_LARGH_MAX_CM) */
    var pcMax = parseFloat(_SS.PASSEPARTOUT_CARTONE_LARGH_MAX_CM);
    if (pcMax > 0) range.max = pcMax;
    var pcDefault = _passCartoneLarghDefault(range);
    if (pcDefault > 0 && !(parseFloat(range.min) > 0)) range.min = pcDefault;
    if (!(state.passCartoneLargh > 0)) state.passCartoneLargh = pcDefault;
    range.addEventListener('input', function () {
      state.passCartoneLargh = parseFloat(range.value);
      pcVal.textContent = range.value;
      _updatePrice(); _drawCanvas(); _saveState();
    });

    $('qasm-confirm-4').addEventListener('click', function () { _goToStep(5); });
  }

  function _enterStep4() {
    var range = $('qasm-pc-range');
    if (!(state.passCartoneLargh > 0)) state.passCartoneLargh = _passCartoneLarghDefault(range);
    range.value = state.passCartoneLargh;
    $('qasm-pc-val').textContent = state.passCartoneLargh;
    var battMm = parseFloat((state.profilo && state.profilo.altezza_battente_mm) || 0);
    $('qasm-pass-sub').textContent = battMm >= BATTENTE_ALTO_MM
      ? 'Il passepartout è il bordo tra l’opera e la cornice: dà respiro all’immagine. Con questa cornice puoi sceglierlo in cartone, in legno o entrambi.'
      : 'Il passepartout è il bordo tra l’opera e la cornice: dà respiro all’immagine. Con questa cornice puoi sceglierlo in cartone.';
    _renderGalleryCartone();
    _renderGalleryLegno();
  }

  /* Larghezza iniziale del bordo in cartone: PRICING_SSOT, poi il minimo dal
     metaobject, poi l'attributo del range che il Liquid scrive dallo stesso dato. */
  function _passCartoneLarghDefault(range) {
    var ssot = parseFloat(_SS.PASSEPARTOUT_CARTONE_LARGH_DEFAULT_CM);
    if (ssot > 0) return ssot;
    var fromData = 0;
    (D && D.passCartone || []).some(function (p) {
      if (p.larghezzaMinimaPass > 0) { fromData = p.larghezzaMinimaPass; return true; }
      return false;
    });
    if (fromData > 0) return fromData;
    var attr = parseFloat(range && range.min);
    if (attr > 0) return attr;
    return parseFloat(range && range.value) || 0;
  }

  function _passTileHtml(dataAttr, sku, nome, imgUrl, selected, extraTitle) {
    var inner = imgUrl
      ? '<img src="' + _esc(imgUrl) + '" alt="" loading="lazy">'
      : '<span class="qasm-gallery-ph">' + _esc((nome || '').split(' ').slice(0, 2).join(' ')) + '</span>';
    return '<div class="qasm-gallery-item' + (selected ? ' selected' : '') + '" role="option" tabindex="0" aria-selected="' + (selected ? 'true' : 'false') + '" ' +
           dataAttr + '="' + _esc(sku) + '" title="' + _esc(nome + (extraTitle || '')) + '">' + inner + '</div>';
  }

  function _renderGalleryCartone() {
    var grid = $('qasm-gallery-cartone');
    var hasNone = !state.passCartoneSku;
    var html = '<div class="qasm-gallery-item qasm-gallery-nessuno' + (hasNone ? ' selected' : '') + '" role="option" tabindex="0" aria-selected="' + (hasNone ? 'true' : 'false') + '" data-pass-cartone="' + NESSUNO_SKU + '" title="Nessuno"><span class="qasm-gallery-ph qasm-gallery-ph--none">Nessuno</span></div>';
    html += (D.passCartone || []).map(function (p) {
      return _passTileHtml('data-pass-cartone', p.sku, nb(p), p.imgUrl, state.passCartoneSku === p.sku);
    }).join('');
    grid.innerHTML = html;
    $('qasm-pc-largh-wrap').style.display = state.passCartoneSku ? '' : 'none';
  }

  function _renderGalleryLegno() {
    var grid    = $('qasm-gallery-legno');
    var section = $('qasm-pass-legno-section');
    var badge   = $('qasm-legno-locked-badge');
    var battMm = parseFloat((state.profilo && state.profilo.altezza_battente_mm) || 0);
    var locked = battMm > 0 && battMm < BATTENTE_ALTO_MM;
    section.classList.toggle('qasm-pass-legno-wrap--locked', locked);
    badge.hidden = !locked;
    if (locked) badge.textContent = 'Richiede un battente di almeno ' + BATTENTE_ALTO_MM + ' mm';
    if (locked && state.passLegnoSku) { state.passLegnoSku = null; state.passLegno = null; }
    var hasNone = !state.passLegnoSku;
    var html = '<div class="qasm-gallery-item qasm-gallery-nessuno' + (hasNone ? ' selected' : '') + '" role="option" tabindex="0" aria-selected="' + (hasNone ? 'true' : 'false') + '" data-pass-legno="' + NESSUNO_SKU + '" title="Nessuno"><span class="qasm-gallery-ph qasm-gallery-ph--none">Nessuno</span></div>';
    html += (D.passLegno || []).map(function (p) {
      return _passTileHtml('data-pass-legno', p.sku, nb(p), p.imgUrl, state.passLegnoSku === p.sku,
        p.larghezzaMm ? ' — ' + p.larghezzaMm + ' mm' : '');
    }).join('');
    grid.innerHTML = html;
  }

  /* ══════════════════════════════════════
     PASSO 5 — RIEPILOGO E ACQUISTO
  ══════════════════════════════════════ */
  function _initStep5() {
    var qty = $('qasm-qty');
    function setQty(n) {
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      state.qty = n; qty.value = n;
      _renderPriceFinal(); _saveState();
    }
    $('qasm-qty-minus').addEventListener('click', function () { setQty(state.qty - 1); });
    $('qasm-qty-plus').addEventListener('click',  function () { setQty(state.qty + 1); });
    qty.addEventListener('change', function () { setQty(qty.value); });
    $('qasm-add-cart').addEventListener('click', _addToCart);
    $('qasm-open-modal').addEventListener('click', _openPreventivoModal);
    $('qasm-open-config').addEventListener('click', _openConfiguratoreConParams);
    $('qasm-foto-required-btn').addEventListener('click', function () { $('qasm-foto-input').click(); });
    $('qasm-riepilogo').addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-goto]');
      if (btn) _goToStep(parseInt(btn.dataset.goto, 10));
    });
  }

  /* Le regole che bloccano l'acquisto, con il passo dove si risolvono. */
  function _validazione() {
    var out = [];
    var v = _dimsValide();
    if (!v.ok) out.push({ passo: 1, testo: v.msg });
    if (!state.profilo) out.push({ passo: 2, testo: 'Scegli una cornice.' });
    if (state.stampaTipo === 'tela' && state.profilo && !_profiloOkPerTela(state.profilo)) {
      out.push({ passo: 2, testo: 'La stampa su tela richiede una cornice con battente alto: scegline un’altra.' });
    }
    var crilex = FR.vincoloCrilex(_fronteSel(), state.base, state.altezza);
    if (crilex) out.push({ passo: 3, testo: crilex });
    var retro = _retroSel();
    if (retro && !FR.retroConsentito(retro, state.base, state.altezza, _ppcLargh(), _pplMm())) {
      out.push({ passo: 3, testo: 'Il retro scelto regge formati finiti fino a ' + retro.maxBase + ' × ' + retro.maxAltezza + ' cm: con queste misure serve un retro da parete.' });
    }
    if (state.stampaTipo && !_artworkFile) {
      out.push({ passo: 1, testo: _artworkImg
        ? 'La foto va ricaricata: per la stampa serve il file originale, non l’anteprima.'
        : 'Hai scelto la stampa: carica la foto da stampare.', foto: true });
    }
    return out;
  }

  function _rowHtml(lbl, val, goto, sub) {
    return '<div class="qasm-summary-row">' +
      '<span class="qasm-summary-lbl">' + _esc(lbl) + '</span>' +
      '<span class="qasm-summary-val"><span>' + _esc(val) + '</span>' + (sub ? '<small>' + _esc(sub) + '</small>' : '') + '</span>' +
      (goto ? '<button type="button" class="qasm-summary-edit" data-goto="' + goto + '" aria-label="Modifica ' + _esc(lbl.toLowerCase()) + '">Modifica</button>' : '<span></span>') +
    '</div>';
  }

  function _renderRiepilogo() {
    var container = $('qasm-riepilogo');
    var rows = [];
    var p = state.profilo;

    var operaVal = (state.base && state.altezza) ? state.base + ' × ' + state.altezza + ' cm' : '—';
    var operaSub = state.stampaTipo
      ? (state.stampaTipo === 'tela' ? 'Stampa su tela' : 'Stampa fotografica') + (state.stampa ? ' · ' + (nb(state.stampa)) : '') + (_artworkFile ? ' · foto caricata' : ' · foto da caricare')
      : 'Stampa o opera fornita da te' + (_artworkImg ? ' · foto in anteprima' : '');
    rows.push(_rowHtml('Opera', operaVal, 1, operaSub));

    rows.push(_rowHtml('Cornice', p ? (_nomeProfilo(p) + ' · ' + _codicePubblico(p)) : '—', 2,
      p ? [_larghezzaProfilo(p), _titoloPulito(p)].filter(Boolean).join(' · ') : ''));

    var fronte = _fronteSel(), retro = _retroSel();
    var protVal = (fronte ? (nb(fronte)) : 'Nessuna protezione') +
                  ' · ' + (retro ? (nb(retro)) : 'Nessun retro');
    rows.push(_rowHtml('Protezione e retro', protVal, 3, (!fronte && !retro) ? 'Solo la cornice, come nella configurazione base' : ''));

    var fin = [];
    if (state.passCartone) fin.push((nb(state.passCartone)) + ' · bordo ' + state.passCartoneLargh + ' cm');
    if (state.passLegno)   fin.push((nb(state.passLegno)) + (state.passLegno.larghezzaMm ? ' · ' + state.passLegno.larghezzaMm + ' mm' : ''));
    rows.push(_rowHtml('Passepartout', fin.length ? fin.join(' + ') : 'Nessuno', 4));

    var n = _nAttaccaglie();
    var battente = FR.dimsBattente ? FR.dimsBattente(state.base, state.altezza, _ppcLargh(), _pplMm()) : null;
    var sezCm = p ? (parseFloat(p.larghezza_sezione_mm) || 0) / 10 : 0;
    var ingombro = (battente && sezCm) ? 'Ingombro esterno circa ' + _fmtCm(battente.b - 2 * _SS.SORMONTO_CM + 2 * sezCm) + ' × ' + _fmtCm(battente.h - 2 * _SS.SORMONTO_CM + 2 * sezCm) + ' cm' : '';
    rows.push(_rowHtml('Attaccaglie', n + ' inclus' + (n === 1 ? 'a' : 'e'), null, ingombro));

    container.innerHTML = rows.join('');
    $('qasm-qty').value = state.qty;
    _renderPriceFinal();
  }

  function _fmtCm(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }

  function _renderPriceFinal() {
    var box    = $('qasm-price-final');
    var numEl  = $('qasm-pf-num');
    var totRow = $('qasm-pf-tot-row');
    var totEl  = $('qasm-pf-tot');
    var spedEl = $('qasm-pf-sped');
    var cartBtn = $('qasm-add-cart');
    var modalBtn = $('qasm-open-modal');
    var noteEl  = $('qasm-cta-note');
    var fotoReq = $('qasm-foto-required');
    var sub = $('qasm-step5-sub');
    var res = _calcPrezzo();
    var errs = _validazione();
    _currentBucket = null;

    var notaSped = 'Spedizione calcolata al checkout · Italia ' + FR.fmtEuro(_SS.SPEDIZIONE) +
                   (_SS.SOGLIA_SPEDIZIONE_GRATUITA ? ', gratuita da ' + FR.fmtEuro(_SS.SOGLIA_SPEDIZIONE_GRATUITA).replace(/,00$/, '') : '') +
                   (D.tempi_consegna ? ' · consegna in ' + D.tempi_consegna : '');
    var errFoto = errs.find(function (e) { return e.foto; });
    fotoReq.hidden = !errFoto;
    if (errFoto) $('qasm-foto-required-txt').textContent = errFoto.testo;
    var altri = errs.filter(function (e) { return !e.foto; });
    sub.innerHTML = altri.length
      ? '<span class="qasm-err-inline">' + _esc(altri[0].testo) + '</span> <button type="button" class="qasm-link-btn" data-goto="' + altri[0].passo + '">Vai al passo ' + altri[0].passo + '</button>'
      : 'Controlla ogni scelta: puoi modificarla e tornare qui.';
    sub.querySelectorAll('button[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { _goToStep(parseInt(b.dataset.goto, 10)); });
    });

    function show(cart, modal, nota) {
      cartBtn.style.display = cart ? '' : 'none';
      cartBtn.disabled = cart && errs.length > 0;
      modalBtn.hidden = !modal;
      noteEl.textContent = nota || '';
    }

    box.classList.remove('only-preventivo');
    totRow.hidden = true;
    if (!res) {
      numEl.textContent = '—'; spedEl.textContent = '';
      $('qasm-pf-label').textContent = 'Prezzo per cornice';
      show(true, false, '');
      return;
    }
    if (res.soloPreventivo) {
      box.classList.add('only-preventivo');
      $('qasm-pf-label').textContent = 'Formato oltre ' + _SS.SOGLIA_SOLO_PREVENTIVO_CM + ' cm';
      numEl.textContent = 'Prezzo su preventivo';
      spedEl.textContent = 'Ti rispondiamo via email con prezzo e spedizione, senza impegno.';
      show(false, true, '');
      return;
    }
    var bucket = _pickBucket(res.prezzoIva);
    if (!bucket) {
      /* prezzo fuori dalle fasce disponibili → preventivo (come il configuratore) */
      $('qasm-pf-label').textContent = 'Stima per cornice';
      numEl.textContent = FR.fmtEuro(res.prezzoIva);
      spedEl.textContent = 'Prezzo confermato via email · ' + notaSped;
      show(false, true, '');
      return;
    }
    _currentBucket = bucket;
    var unit = bucket.c / 100;
    $('qasm-pf-label').textContent = 'Prezzo per cornice';
    numEl.textContent = FR.fmtEuro(unit);
    if (state.qty > 1) { totRow.hidden = false; totEl.textContent = FR.fmtEuro(unit * state.qty) + ' (× ' + state.qty + ')'; }
    spedEl.textContent = notaSped;
    show(true, false, 'Paghi alla conferma dell’ordine. Il prezzo che vedi è quello del carrello.');
  }

  /* ══════════════════════════════════════
     PREZZO — formula del configuratore (FR.corniceNetto), con varianti
  ══════════════════════════════════════ */
  /* `over` sovrascrive singole scelte (profilo, fronteSku, retroSku) per calcolare il
     prezzo di un'alternativa: e' cosi' che le card e le opzioni mostrano differenze
     fra prezzi FINALI, non somme di componenti. */
  function _calcPrezzoCon(over) {
    over = over || {};
    var profiloRaw = over.profilo !== undefined ? over.profilo : state.profilo;
    if (!state.base || !state.altezza || !profiloRaw) return null;
    var fascia = FR.getFascia(state.base, state.altezza);
    if (fascia.soloPreventivo) return { soloPreventivo: true };
    var isGrande = fascia.isGrande;
    var mk = FR.makeMk(isGrande);
    var profilo = {
      costoMl: parseFloat(profiloRaw.costo_fornitore_1) || 0,
      larghezzaMm: parseFloat(profiloRaw.larghezza_sezione_mm) || 0,
      markup: profiloRaw.markup, markupGrande: profiloRaw.markupGrande != null ? profiloRaw.markupGrande : profiloRaw.markup_grande,
      nome: profiloRaw.nome, nome_breve: profiloRaw.nome_breve || '', sku: profiloRaw.sku,
    };
    var fronteSku = over.fronteSku !== undefined ? over.fronteSku : state.fronteSku;
    var retroSku  = over.retroSku  !== undefined ? over.retroSku  : state.retroSku;
    var fronte = (D.fronti || []).find(function (x) { return x.sku === fronteSku; }) || null;
    var retro  = (D.retri  || []).find(function (x) { return x.sku === retroSku;  }) || null;
    var attEntry = (D.accessori || []).find(function (a) {
      return (a.categoria || '').indexOf('attaccaglie') !== -1;
    }) || (D.accessori || [])[0];
    var voci = FR.corniceNetto({
      base: state.base, altezza: state.altezza, profilo: profilo,
      fronte: fronte, retro: retro,
      passLegno:   state.passLegno   || null,
      passCartone: state.passCartone || null,
      passCartoneLargh: state.passCartoneLargh,
      stampa: (state.stampaTipo && state.stampa) ? state.stampa : null,
      stampaTipo: state.stampaTipo,
      attaccaglie: attEntry ? [{ prezzo: attEntry.prezzo, qty: _nAttaccaglie() }] : [],
      isGrande: isGrande, mk: mk, P: _SS,
    });
    if (mk.mancanti.length) {
      console.error('[QASM] markup assente su: ' + mk.mancanti.join(', ') + ' — prezzo non calcolabile');
      return null;
    }
    var imponibile = voci.netto + FR.imballoNetto(fascia);
    return { prezzoIva: imponibile * (1 + _SS.IVA), grande: isGrande, soloPreventivo: false };
  }
  function _calcPrezzo() { return _calcPrezzoCon(null); }

  function _pickBucket(euro) { return FR.core.pickBucket(euro, window.SU_MISURA_BUCKETS); }

  /* Prezzo di vendita (fascia, cioe' quello del carrello) per una variante; null se
     non calcolabile o fuori fascia. */
  function _prezzoVenditaCon(over) {
    var res = _calcPrezzoCon(over);
    if (!res || res.soloPreventivo) return null;
    var b = _pickBucket(res.prezzoIva);
    return b ? b.c / 100 : null;
  }
  function _prezzoVendita() { return _prezzoVenditaCon(null); }
  function _deltaEuro(over) {
    var a = _prezzoVendita(), b = _prezzoVenditaCon(over);
    if (a == null || b == null) return null;
    return b - a;
  }

  /* Cosa e' compreso oltre alla cornice e alle attaccaglie */
  function _inclusiExtra() {
    var out = [];
    var f = _fronteSel(), r = _retroSel();
    if (f) out.push(nb(f));
    if (r) out.push(nb(r));
    if (state.passCartone) out.push('passepartout ' + state.passCartoneLargh + ' cm');
    if (state.passLegno)   out.push('passepartout in legno');
    if (state.stampaTipo)  out.push(state.stampaTipo === 'tela' ? 'stampa su tela' : 'stampa fotografica');
    return out;
  }
  function _inclusiTesto() {
    var n = _nAttaccaglie();
    var base = ['cornice', n + ' attaccagli' + (n === 1 ? 'a' : 'e')];
    return 'Include: ' + base.concat(_inclusiExtra()).join(', ');
  }

  /* ══════════════════════════════════════
     PREZZO A VIDEO — colonna, barra mobile, mini riepilogo
  ══════════════════════════════════════ */
  function _updatePrice() {
    var valEl  = $('qasm-price-val');
    var noteEl = $('qasm-price-note');
    var incEl  = $('qasm-price-inclusi');
    var labEl  = $('qasm-price-label');
    var barVal = $('qasm-bar-val');
    var barLab = $('qasm-bar-label');
    var res = _calcPrezzo();

    function set(label, val, empty, inclusi, note) {
      labEl.textContent = label;
      valEl.textContent = val; valEl.dataset.empty = empty ? 'true' : 'false';
      incEl.textContent = inclusi || '';
      noteEl.textContent = note || '';
      barLab.textContent = label;
      barVal.textContent = val; barVal.dataset.empty = empty ? 'true' : 'false';
    }

    if (!res) {
      var msg = !state.profilo ? 'Scegli la cornice' : 'Inserisci le misure';
      set('Prezzo', msg, true, '', '');
    } else if (res.soloPreventivo) {
      set('Formato oltre ' + _SS.SOGLIA_SOLO_PREVENTIVO_CM + ' cm', 'Su preventivo', false, '', 'Completa il percorso: ti rispondiamo via email.');
    } else {
      var bucket = _pickBucket(res.prezzoIva);
      var shown = bucket ? (bucket.c / 100) : res.prezzoIva;
      var notes = [];
      if (res.grande) notes.push('Imballo rinforzato compreso (formato oltre ' + _SS.SOGLIA_SUPPLEMENTO_CM + ' cm)');
      if (!bucket) notes.push('Stima: prezzo confermato via email');
      set(bucket ? 'Prezzo per cornice' : 'Stima per cornice', FR.fmtEuro(shown), false, _inclusiTesto(), notes.join(' · '));
    }
    _renderMini();
    _showProfiloSel();
    if (state.currentStep === 5) _renderPriceFinal();
  }

  /* Riepilogo breve sotto il prezzo (desktop): le scelte fatte, con «Modifica». */
  function _renderMini() {
    var el = $('qasm-mini');
    if (!el) return;
    if (!state.profilo || state.currentStep === 5) { el.hidden = true; return; }
    var p = state.profilo, f = _fronteSel(), r = _retroSel();
    var righe = [
      ['Opera', state.base + ' × ' + state.altezza + ' cm' + (state.stampaTipo ? (state.stampaTipo === 'tela' ? ' · stampa su tela' : ' · stampa foto') : ''), 1],
      ['Cornice', _nomeProfilo(p) + ' · ' + _codicePubblico(p), 2],
    ];
    if (state.visited[3] || f || r) righe.push(['Protezione', (f ? nb(f) : 'Nessuna') + ' · ' + (r ? nb(r) : 'Nessun retro'), 3]);
    if (state.visited[4] || state.passCartone || state.passLegno) {
      var fin = [];
      if (state.passCartone) fin.push(nb(state.passCartone) + ' - bordo ' + state.passCartoneLargh + ' cm');
      if (state.passLegno)   fin.push(nb(state.passLegno));
      righe.push(['Passepartout', fin.length ? fin.join(' + ') : 'Nessuno', 4]);
    }
    el.innerHTML = righe.map(function (r) {
      return '<div class="qasm-mini-row"><span class="qasm-mini-lbl">' + _esc(r[0]) + '</span><span class="qasm-mini-val">' + _esc(r[1]) + '</span>' +
             '<button type="button" class="qasm-summary-edit" data-goto="' + r[2] + '" aria-label="Modifica ' + _esc(r[0].toLowerCase()) + '">Modifica</button></div>';
    }).join('');
    el.hidden = false;
    el.querySelectorAll('button[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { _closeBar(); _goToStep(parseInt(b.dataset.goto, 10)); });
    });
  }

  /* barra compatta (mobile): apre/chiude anteprima e riepilogo */
  function _initBar() {
    var bar = $('qasm-bar');
    if (!bar) return;
    bar.addEventListener('click', function () {
      var card = $('qasm-live-card');
      var open = !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      bar.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('qasm-sheet-open', open);
      if (open) _drawCanvas();
    });
  }
  function _closeBar() {
    var card = $('qasm-live-card');
    if (card && card.classList.contains('is-open')) {
      card.classList.remove('is-open');
      $('qasm-bar').setAttribute('aria-expanded', 'false');
      document.body.classList.remove('qasm-sheet-open');
    }
  }

  /* ══════════════════════════════════════
     CARRELLO NATIVO — stesso meccanismo del configuratore
     (variante "fascia di prezzo" + properties testuali + /cart/add.js)
  ══════════════════════════════════════ */
  function _buildCartProperties() {
    var fronte = _fronteSel(), retro = _retroSel();
    var res = _calcPrezzo();
    var attEntry = (D.accessori || []).find(function (a) {
      return (a.categoria || '').indexOf('attaccaglie') !== -1;
    });
    var nAtt = attEntry ? _nAttaccaglie() : 0;
    var props = {
      'Tipologia':         'Cornice su misura',
      'Dimensioni':        state.base + ' × ' + state.altezza + ' cm',
      'Profilo asta':      nb(state.profilo),
      'Fronte':            fronte ? nb(fronte) : 'Nessuno',
      'Retro':             retro  ? nb(retro)  : 'Nessuno',
      '_prezzo_calcolato_pezzo': (res && !res.soloPreventivo ? res.prezzoIva : 0).toFixed(2),
    };
    if (state.stampaTipo && state.stampa) {
      props['Stampa'] = nb(state.stampa) + (state.stampaTipo === 'tela' ? ' - su telaio' : '');
    }
    if (state.passLegno)   props['Passepartout in legno']   = nb(state.passLegno);
    if (state.passCartone) props['Passepartout in cartone'] = nb(state.passCartone) + ' - bordo ' + state.passCartoneLargh + ' cm';
    if (attEntry) props['Accessori'] = nAtt + ' × ' + nb(attEntry);
    /* Chiavi NASCOSTE: le stesse di ConfiguratoreAste._buildCartProperties (SSOT dei nomi:
       configuratore-universale.js; lettori: core/fotorecord/ordini_articoli.py). */
    props['_tipo_prodotto'] = 'aste';
    props['_profilo_id_db'] = state.profilo && state.profilo.sku ? _profiloCodice(state.profilo) : '';
    props['_fronte_sku']    = fronte ? (fronte.sku || '') : '';
    props['_retro_sku']     = retro  ? (retro.sku  || '') : '';
    if (state.stampaTipo && state.stampa) {
      props['_stampa_tipo'] = state.stampaTipo;
      props['_stampa_sku']  = state.stampa.sku || '';
    }
    if (state.passCartone) {
      props['_pp_cartone_sku']      = state.passCartone.sku || '';
      props['_pp_cartone_largh_cm'] = String(state.passCartoneLargh || '');
    }
    if (state.passLegno) props['_pp_legno_sku'] = state.passLegno.sku || '';
    if (attEntry && nAtt > 0) props['_accessori_json'] = JSON.stringify([{ sku: attEntry.sku, qty: nAtt }]);
    return props;
  }

  function _addToCart() {
    var errs = _validazione();
    if (errs.length) { _renderPriceFinal(); return; }
    var bucket = _currentBucket || _pickBucket((_calcPrezzo() || {}).prezzoIva);
    if (!bucket || !(bucket.id > 0)) {
      console.error('[QASM] add to cart: nessuna fascia di prezzo disponibile');
      return;
    }
    var btn = $('qasm-add-cart');
    var oldHtml = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Aggiunta al carrello…';
    var props = _buildCartProperties();
    /* Come i configuratori: la foto originale e' il master di stampa, il canvas il
       mockup di conferma (`_anteprima`) che il job ordini archivia. */
    if (state.stampaTipo && state.stampa && _artworkFile) props['Foto da stampare'] = _artworkFile;
    var canvas = $('qasm-canvas');
    var cattura = new Promise(function (resolve) {
      if (!canvas) return resolve(null);
      try { canvas.toBlob(function (b) { resolve(b); }, 'image/png'); } catch (e) { resolve(null); }
    });
    cattura.then(function (anteprima) {
      if (anteprima) props['_anteprima'] = anteprima;
      return FR.core.addToCart({ items: [{ id: bucket.id, quantity: state.qty || 1, properties: props }] });
    }).catch(function (e) {
      console.error('[QASM] add to cart error', e);
      btn.disabled = false; btn.innerHTML = oldHtml;
    });
  }

  /* ══════════════════════════════════════
     STATO IN SESSIONE — tornare indietro (anche dal configuratore) senza perdere le scelte
     Solo scelte non personali; la foto viaggia a parte (ARTWORK_KEY, anteprima ridotta:
     il file originale non e' serializzabile e alla ripresa si chiede di ricaricarlo).
     Alla ripresa ogni id viene rivalidato sul catalogo corrente.
  ══════════════════════════════════════ */
  function _saveState() {
    try {
      sessionStorage.setItem(STATE_KEY, JSON.stringify({
        v: STATE_VERSION, step: state.currentStep, base: state.base, altezza: state.altezza,
        profiloSku: state.profiloSku, fronteSku: state.fronteSku, retroSku: state.retroSku,
        passCartoneSku: state.passCartoneSku, passCartoneLargh: state.passCartoneLargh,
        passLegnoSku: state.passLegnoSku, stampaTipo: state.stampaTipo, qty: state.qty,
        filters: state.filters, visited: state.visited,
      }));
    } catch (e) {}
  }

  function _restoreState() {
    var s = null;
    try { s = JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null'); } catch (e) { s = null; }
    if (!s || s.v !== STATE_VERSION) return 0;
    if (s.base > 0 && s.altezza > 0) { state.base = s.base; state.altezza = s.altezza; }
    if (s.filters) state.filters = Object.assign({ stile: '', colore: '', finitura: '', battente: '' }, s.filters);
    if (s.visited) state.visited = Object.assign({ 1: true }, s.visited);
    state.qty = Math.max(1, Math.min(99, parseInt(s.qty, 10) || 1));
    if (s.stampaTipo === 'foto' || s.stampaTipo === 'tela') { state.stampaTipo = s.stampaTipo; state.stampa = _resolveStampa(s.stampaTipo); }
    var p = s.profiloSku ? profiliAll.find(function (x) { return x.sku === s.profiloSku; }) : null;
    if (p) { state.profiloSku = p.sku; state.profilo = p; _loadFrameImg(p.immagine_url || ''); }
    if (s.fronteSku && (D.fronti || []).some(function (x) { return x.sku === s.fronteSku; })) state.fronteSku = s.fronteSku;
    if (s.retroSku  && (D.retri  || []).some(function (x) { return x.sku === s.retroSku;  })) state.retroSku  = s.retroSku;
    var pc = s.passCartoneSku ? (D.passCartone || []).find(function (x) { return x.sku === s.passCartoneSku; }) : null;
    if (pc) { state.passCartoneSku = pc.sku; state.passCartone = pc; state.passCartoneLargh = s.passCartoneLargh > 0 ? s.passCartoneLargh : _passCartoneLarghDefault($('qasm-pc-range')); _loadPassCartoneImg(pc.imgUrl || ''); }
    var pl = s.passLegnoSku ? (D.passLegno || []).find(function (x) { return x.sku === s.passLegnoSku; }) : null;
    if (pl) { state.passLegnoSku = pl.sku; state.passLegno = pl; _loadPassLegnoImg(pl.imgUrl || ''); }
    _onProfiloChange();
    var step = parseInt(s.step, 10) || 1;
    return _canEnter(step) ? step : (state.profilo ? 2 : 1);
  }

  /* ══════════════════════════════════════
     CANVAS — anteprima con immagini reali
  ══════════════════════════════════════ */
  function _initCanvas() {
    var fotoBtn   = $('qasm-foto-btn');
    var fotoInput = $('qasm-foto-input');
    var fotoClear = $('qasm-foto-clear');
    $('qasm-canvas').style.display = 'none';
    $('qasm-canvas-ph').style.display = 'flex';
    if (fotoBtn)   fotoBtn.addEventListener('click', function () { if (fotoInput) fotoInput.click(); });
    if (fotoInput) fotoInput.addEventListener('change', function (e) {
      var file = e.target.files[0]; if (!file) return;
      _setArtworkFromFile(file, fotoInput);
    });
    if (fotoClear) fotoClear.addEventListener('click', _clearArtwork);
  }

  /* Validazione + caricamento della foto (JPG/PNG, max 20 MB, come il configuratore).
     File ORIGINALE conservato per la stampa; l'immagine ridotta per l'anteprima. */
  function _setArtworkFromFile(file, inputEl) {
    var err = $('qasm-err-foto');
    if (!file) return;
    if (!/^image\/(jpeg|png)$/.test(file.type || '')) {
      err.textContent = 'Carica la foto in formato JPG o PNG.'; err.hidden = false;
      if (inputEl) inputEl.value = '';
      return;
    }
    if (file.size > ARTWORK_MAX_BYTES) {
      err.textContent = 'La foto supera i 20 MB: dopo l’ordine invia il file originale a info@fotorecord.it indicando il numero d’ordine.'; err.hidden = false;
      if (inputEl) inputEl.value = '';
      return;
    }
    err.hidden = true;
    _artworkFile = file;
    var reader = new FileReader();
    reader.onload = function (ev) {
      var raw = new Image();
      raw.onload = function () {
        var dataUrl = _downscaleDataURL(raw, ARTWORK_MAX_DIM) || ev.target.result;
        _setArtworkFromDataURL(dataUrl);
        try { sessionStorage.setItem(ARTWORK_KEY, dataUrl); } catch (e) { /* quota: solo preview locale */ }
      };
      raw.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  function _setArtworkFromDataURL(dataUrl) {
    if (!dataUrl) return;
    var img = new Image();
    img.onload = function () {
      _artworkImg     = img;
      _artworkDataUrl = dataUrl;
      _reflectArtworkUI(true);
      _drawCanvas();
      if (state.currentStep === 5) _renderRiepilogo();
    };
    img.src = dataUrl;
  }

  function _clearArtwork() {
    _artworkImg = null; _artworkDataUrl = ''; _artworkFile = null;
    var fotoInput = $('qasm-foto-input');
    if (fotoInput) fotoInput.value = '';
    try { sessionStorage.removeItem(ARTWORK_KEY); } catch (e) {}
    _reflectArtworkUI(false);
    _drawCanvas();
    if (state.currentStep === 5) _renderRiepilogo();
  }

  /* Sincronizza la UI della foto: colonna (rimuovi) e passo 1 (vuoto/pieno/miniatura).
     Distingue l'anteprima dal file originale: dopo un reload resta la miniatura ma il
     master di stampa va ricaricato, e lo si dice. */
  function _reflectArtworkUI(has) {
    var fotoClear = $('qasm-foto-clear');
    if (fotoClear) fotoClear.style.display = has ? 'inline' : 'none';
    var empty  = $('qasm-dropzone-empty');
    var filled = $('qasm-dropzone-filled');
    var thumb  = $('qasm-dropzone-thumb');
    var dz     = $('qasm-dropzone');
    var status = $('qasm-dropzone-status');
    var note   = $('qasm-dropzone-note');
    if (empty)  empty.hidden  = has;
    if (filled) filled.hidden = !has;
    if (dz)     dz.classList.toggle('has-foto', has);
    if (thumb && has && _artworkDataUrl) thumb.src = _artworkDataUrl;
    if (has && status && note) {
      if (_artworkFile) {
        status.textContent = 'Foto caricata';
        status.classList.remove('is-warn');
        note.textContent = state.stampaTipo ? 'Useremo questo file per la stampa.' : 'La vedi nella cornice mentre scegli.';
      } else {
        status.textContent = state.stampaTipo ? 'Anteprima presente, file da ricaricare' : 'Anteprima della sessione';
        status.classList.toggle('is-warn', !!state.stampaTipo);
        note.textContent = state.stampaTipo ? 'Per la stampa serve il file originale: caricalo di nuovo.' : 'Per la sola anteprima va bene così.';
      }
    }
    var thumbBar = $('qasm-bar-thumb');
    if (thumbBar) thumbBar.style.backgroundImage = (has && _artworkDataUrl) ? 'url(' + _artworkDataUrl + ')' : '';
  }

  /* Riduce un'immagine entro maxDim e restituisce un dataURL JPEG compatto */
  function _downscaleDataURL(img, maxDim) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    if (!w || !h) return null;
    var scale = Math.min(1, maxDim / Math.max(w, h));
    var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    c.getContext('2d').drawImage(img, 0, 0, cw, ch);
    try { return c.toDataURL('image/jpeg', 0.85); } catch (e) { return null; }
  }

  /* _drawCanvas — preview con immagini reali (allineato al configuratore):
     LAYER 1 cornice (9-slice da _frameImg, fallback gradiente colore)
     LAYER 2 pass legno (9-slice da _passLegnoImg, fallback PASS_LEGNO_COLOR)
     LAYER 3 pass cartone (pattern repeat da _passCartoneImg, fallback PASS_CARTONE_COLOR)
     LAYER 4 area opera (artwork drawCover o sfondo bianco) */
  function _drawCanvas() {
    var canvas = $('qasm-canvas');
    var ph     = $('qasm-canvas-ph');
    var bar    = $('qasm-bar-thumb');

    if (!state.base || !state.altezza || !state.profilo) {
      canvas.style.display = 'none';
      ph.style.display     = 'flex';
      if (bar) bar.classList.remove('has-frame');
      return;
    }
    canvas.style.display = 'block';
    ph.style.display     = 'none';
    canvas.width  = CVS_W;
    canvas.height = CVS_H;
    var ctx = canvas.getContext('2d');
    var W = CVS_W, H = CVS_H;

    var sezioneMm   = parseFloat(state.profilo.larghezza_sezione_mm) || 30;
    var sezioneCm   = sezioneMm / 10.0;
    var passLegnoCm = state.passLegno ? (parseFloat(state.passLegno.larghezzaMm) || 0) / 10.0 : 0;
    var passCartoneCm = state.passCartone ? (parseFloat(state.passCartoneLargh) || 0) : 0;

    var totW  = state.base    + 2 * (passLegnoCm + passCartoneCm) + 2 * sezioneCm;
    var totH  = state.altezza + 2 * (passLegnoCm + passCartoneCm) + 2 * sezioneCm;
    var scale = Math.min((W - CVS_PAD * 2) / totW, (H - CVS_PAD * 2) / totH);
    var drawW = totW * scale;
    var drawH = totH * scale;
    var fx    = (W - drawW) / 2;
    var fy    = (H - drawH) / 2;
    var profPx  = sezioneCm    * scale;
    var legnoPx = passLegnoCm  * scale;
    var cartPx  = passCartoneCm * scale;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#f0ede8';
    ctx.fillRect(0, 0, W, H);

    // l'ombra delle cornici, la stessa del configuratore e delle immagini (24/10/2026)
    if (window.FOTORECORD && window.FOTORECORD.core && window.FOTORECORD.core.ombraCornice) {
      window.FOTORECORD.core.ombraCornice(ctx, fx, fy, drawW, drawH);
    }
    ctx.fillStyle = '#ccc';
    ctx.fillRect(fx, fy, drawW, drawH);

    if (_frameImg && _frameImg.naturalWidth > 0) {
      var slicePx = _frameImg.naturalWidth * (sezioneMm / 200);
      _draw9Slice(ctx, _frameImg, slicePx, fx, fy, drawW, drawH, profPx);
    } else {
      _drawFrameFallback(ctx, fx, fy, drawW, drawH, profPx, state.profilo.colore);
    }

    var opX = fx + profPx, opY = fy + profPx;
    var opW = drawW - 2 * profPx, opH = drawH - 2 * profPx;

    if (legnoPx > 0) {
      if (_passLegnoImg && _passLegnoImg.naturalWidth > 0) {
        var sLeg = _passLegnoImg.naturalWidth * ((parseFloat(state.passLegno.larghezzaMm) || 30) / 200);
        _draw9Slice(ctx, _passLegnoImg, sLeg, opX, opY, opW, opH, legnoPx);
      } else {
        ctx.fillStyle = PASS_LEGNO_COLOR;
        ctx.fillRect(opX, opY, opW, legnoPx);
        ctx.fillRect(opX, opY + opH - legnoPx, opW, legnoPx);
        ctx.fillRect(opX, opY + legnoPx, legnoPx, opH - 2 * legnoPx);
        ctx.fillRect(opX + opW - legnoPx, opY + legnoPx, legnoPx, opH - 2 * legnoPx);
      }
      opX += legnoPx; opY += legnoPx; opW -= 2 * legnoPx; opH -= 2 * legnoPx;
    }

    if (cartPx > 0) {
      if (_passCartoneImg && _passCartoneImg.naturalWidth > 0) {
        var tileKey = (state.passCartoneSku || '') + '_' + Math.round(cartPx);
        if (_passCartoneTileKey !== tileKey) {
          var ts = Math.max(1, Math.round(cartPx));
          var off = document.createElement('canvas');
          off.width = ts; off.height = ts;
          off.getContext('2d').drawImage(_passCartoneImg, 0, 0, ts, ts);
          _passCartoneTile    = off;
          _passCartoneTileKey = tileKey;
        }
        var pattern = ctx.createPattern(_passCartoneTile, 'repeat');
        var bands = [
          { x: opX,                y: opY,                w: opW,    h: cartPx },
          { x: opX,                y: opY + opH - cartPx, w: opW,    h: cartPx },
          { x: opX,                y: opY + cartPx,       w: cartPx, h: opH - 2 * cartPx },
          { x: opX + opW - cartPx, y: opY + cartPx,       w: cartPx, h: opH - 2 * cartPx }
        ];
        bands.forEach(function (b) {
          ctx.save();
          ctx.beginPath(); ctx.rect(b.x, b.y, b.w, b.h); ctx.clip();
          if (pattern.setTransform) pattern.setTransform(new DOMMatrix().translate(b.x, b.y));
          ctx.fillStyle = pattern;
          ctx.fillRect(b.x, b.y, b.w, b.h);
          ctx.restore();
        });
        ctx.strokeStyle = 'rgba(0,0,0,0.12)'; ctx.lineWidth = 1;
        ctx.strokeRect(opX + cartPx, opY + cartPx, opW - 2 * cartPx, opH - 2 * cartPx);
      } else {
        ctx.fillStyle = PASS_CARTONE_COLOR;
        ctx.fillRect(opX, opY, opW, cartPx);
        ctx.fillRect(opX, opY + opH - cartPx, opW, cartPx);
        ctx.fillRect(opX, opY + cartPx, cartPx, opH - 2 * cartPx);
        ctx.fillRect(opX + opW - cartPx, opY + cartPx, cartPx, opH - 2 * cartPx);
      }
      opX += cartPx; opY += cartPx; opW -= 2 * cartPx; opH -= 2 * cartPx;
    }

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(opX, opY, opW, opH);
    if (_artworkImg && opW > 0 && opH > 0) {
      _drawImgCover(ctx, _artworkImg, opX, opY, opW, opH);
    }
    ctx.strokeStyle = 'rgba(0,0,0,0.08)'; ctx.lineWidth = 1;
    ctx.strokeRect(fx, fy, drawW, drawH);

    /* miniatura per la barra mobile: la foto del cliente se c'e' (e' il suo schermo),
       altrimenti il colore del profilo, che basta a riconoscere la cornice */
    if (bar) {
      bar.classList.add('has-frame');
      if (!_artworkDataUrl) bar.style.background = _colorHex(state.profilo.colore || '');
    }
  }

  function _draw9Slice(ctx, img, slicePx, dx, dy, dw, dh, destSlice) {
    var sw = img.naturalWidth, sh = img.naturalHeight;
    var s = slicePx, d = destSlice;
    ctx.drawImage(img, 0,      0,      s, s, dx,          dy,          d, d);
    ctx.drawImage(img, sw - s, 0,      s, s, dx + dw - d, dy,          d, d);
    ctx.drawImage(img, sw - s, sh - s, s, s, dx + dw - d, dy + dh - d, d, d);
    ctx.drawImage(img, 0,      sh - s, s, s, dx,          dy + dh - d, d, d);
    ctx.drawImage(img, s,      0,      sw - 2 * s, s,      dx + d, dy,          dw - 2 * d, d);
    ctx.drawImage(img, s,      sh - s, sw - 2 * s, s,      dx + d, dy + dh - d, dw - 2 * d, d);
    ctx.drawImage(img, 0,      s,      s, sh - 2 * s,      dx,     dy + d,      d, dh - 2 * d);
    ctx.drawImage(img, sw - s, s,      s, sh - 2 * s,      dx + dw - d, dy + d, d, dh - 2 * d);
  }

  function _drawImgCover(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth, ih = img.naturalHeight;
    if (!iw || !ih) return;
    var sc = Math.max(w / iw, h / ih);
    var sw = iw * sc, sh = ih * sc;
    var sx = x + (w - sw) / 2, sy = y + (h - sh) / 2;
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.drawImage(img, sx, sy, sw, sh);
    ctx.restore();
  }

  function _drawFrameFallback(ctx, x, y, w, h, p, colore) {
    var base = _colorHex(colore || '');
    var light = _shadeColor(base,  40);
    var dark  = _shadeColor(base, -35);
    ctx.save();
    var gT = ctx.createLinearGradient(0, y, 0, y + p);
    gT.addColorStop(0, light); gT.addColorStop(1, base);
    ctx.fillStyle = gT;
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + w, y); ctx.lineTo(x + w - p, y + p); ctx.lineTo(x + p, y + p); ctx.closePath(); ctx.fill();
    var gB = ctx.createLinearGradient(0, y + h - p, 0, y + h);
    gB.addColorStop(0, base); gB.addColorStop(1, dark);
    ctx.fillStyle = gB;
    ctx.beginPath(); ctx.moveTo(x, y + h); ctx.lineTo(x + w, y + h); ctx.lineTo(x + w - p, y + h - p); ctx.lineTo(x + p, y + h - p); ctx.closePath(); ctx.fill();
    var gL = ctx.createLinearGradient(x, 0, x + p, 0);
    gL.addColorStop(0, light); gL.addColorStop(1, base);
    ctx.fillStyle = gL;
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + p, y + p); ctx.lineTo(x + p, y + h - p); ctx.lineTo(x, y + h); ctx.closePath(); ctx.fill();
    var gR = ctx.createLinearGradient(x + w - p, 0, x + w, 0);
    gR.addColorStop(0, base); gR.addColorStop(1, dark);
    ctx.fillStyle = gR;
    ctx.beginPath(); ctx.moveTo(x + w, y); ctx.lineTo(x + w - p, y + p); ctx.lineTo(x + w - p, y + h - p); ctx.lineTo(x + w, y + h); ctx.closePath(); ctx.fill();
    ctx.restore();
  }

  function _shadeColor(hex, amt) {
    var n = parseInt((hex || '#cccccc').replace('#', ''), 16);
    var r = Math.min(255, Math.max(0, (n >> 16) + amt));
    var g = Math.min(255, Math.max(0, ((n >> 8) & 0xff) + amt));
    var b = Math.min(255, Math.max(0, (n & 0xff) + amt));
    return '#' + [r, g, b].map(function (x) { return x.toString(16).padStart(2, '0'); }).join('');
  }

  /* loader immagini */
  function _loadFrameImg(url) {
    if (url === _frameImgUrl) return;
    _frameImgUrl = url; _frameImg = null;
    if (!url) { _drawCanvas(); return; }
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { if (_frameImgUrl === url) { _frameImg = img; _drawCanvas(); } };
    img.onerror = function () { _frameImg = null; _drawCanvas(); };
    img.src = url;
  }
  function _loadPassLegnoImg(url) {
    if (url === _passLegnoImgUrl) return;
    _passLegnoImgUrl = url; _passLegnoImg = null;
    if (!url) { _drawCanvas(); return; }
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { if (_passLegnoImgUrl === url) { _passLegnoImg = img; _drawCanvas(); } };
    img.onerror = function () { _passLegnoImg = null; _drawCanvas(); };
    img.src = url;
  }
  function _loadPassCartoneImg(url) {
    if (url === _passCartoneImgUrl) return;
    _passCartoneImgUrl = url; _passCartoneImg = null; _passCartoneTile = null; _passCartoneTileKey = '';
    if (!url) { _drawCanvas(); return; }
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { if (_passCartoneImgUrl === url) { _passCartoneImg = img; _drawCanvas(); } };
    img.onerror = function () { _passCartoneImg = null; _drawCanvas(); };
    img.src = url;
  }

  /* ══════════════════════════════════════
     REDIRECT CONFIGURATORE — stessi parametri letti da _applyUrlParams
  ══════════════════════════════════════ */
  function _openConfiguratoreConParams() {
    var baseUrl = (D && D.url_configuratore) || '/products/cornici-su-misura';
    var p = new URLSearchParams();
    if (state.profiloSku)    p.set('sku',    state.profiloSku);
    if (state.base)          p.set('base',   String(state.base));
    if (state.altezza)       p.set('alt',    String(state.altezza));
    /* fronte/retro VUOTI = scelta deliberata «Nessuno» (il configuratore distingue
       il parametro assente dal parametro vuoto) */
    p.set('fronte', state.fronteSku || '');
    p.set('retro',  state.retroSku  || '');
    if (state.passCartoneSku) {
      p.set('passC',  state.passCartoneSku);
      p.set('passCL', String(state.passCartoneLargh));
    }
    if (state.passLegnoSku) p.set('passL', state.passLegnoSku);
    if (state.stampaTipo)   p.set('stampa', state.stampaTipo);
    if (!_artworkImg) { try { sessionStorage.removeItem(ARTWORK_KEY); } catch (e) {} }
    _saveState();
    var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
    window.location.href = baseUrl + sep + p.toString();
  }

  /* ══════════════════════════════════════
     PREVENTIVO — modal (form condiviso /contact), solo quando il prezzo non e' in vendita
  ══════════════════════════════════════ */
  function _initPreventivoModal() {
    var overlay = $('qasm-modal-overlay');
    if (!overlay) return;
    var close  = $('qasm-modal-close');
    var cancel = $('qasm-modal-cancel');
    var form   = $('qasm-modal-form');
    if (close)  close.addEventListener('click', _closePreventivoModal);
    if (cancel) cancel.addEventListener('click', _closePreventivoModal);
    overlay.addEventListener('click', function (e) {
      if (e.target.id === 'qasm-modal-overlay') _closePreventivoModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) _closePreventivoModal();
    });
    if (form) form.addEventListener('submit', function () {
      try { sessionStorage.setItem('qasm_success', '1'); } catch (e) {}
      var noteEl = $('qasm-modal-note');
      var bodyEl = $('qasm-modal-body');
      if (noteEl && bodyEl && noteEl.value.trim()) {
        bodyEl.value += '\n\nNote aggiuntive:\n' + noteEl.value.trim();
      }
      if (typeof window.fotorecordLeadConversion === 'function') {
        var _res = _calcPrezzo();
        var _val = (_res && !_res.soloPreventivo) ? _res.prezzoIva : null;
        window.fotorecordLeadConversion('quiz_aste', _val);
      }
    });
  }

  function _openPreventivoModal() {
    var overlay = $('qasm-modal-overlay');
    if (!overlay) { _openConfiguratoreConParams(); return; }
    _buildModalRecap();
    _buildModalBody();
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function _closePreventivoModal() {
    var overlay = $('qasm-modal-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function _recapRows() {
    var rows = [];
    var fronte = _fronteSel(), retro = _retroSel();
    rows.push(['Dimensioni opera', (state.base && state.altezza) ? state.base + ' × ' + state.altezza + ' cm' : '—']);
    rows.push(['Profilo asta', state.profilo ? (_titoloPulito(state.profilo) + ' (' + _codicePubblico(state.profilo) + ')') : '—']);
    rows.push(['Fronte', fronte ? fronte.nome : 'Nessuno']);
    rows.push(['Retro',  retro  ? retro.nome  : 'Nessuno']);
    if (state.stampaTipo && state.stampa) rows.push(['Stampa', state.stampa.nome + (state.stampaTipo === 'tela' ? ' - telaio incluso' : '')]);
    if (state.passLegno)   rows.push(['Passepartout in legno', state.passLegno.nome]);
    if (state.passCartone) rows.push(['Passepartout in cartone', state.passCartone.nome + ' — ' + state.passCartoneLargh + ' cm']);
    rows.push(['Attaccaglie', String(_nAttaccaglie())]);
    rows.push(['Quantità', String(state.qty || 1)]);
    rows.push(['Foto caricata dal cliente', _artworkImg ? 'Sì' : 'No']);
    return rows;
  }

  function _buildModalRecap() {
    var el = $('qasm-modal-recap-rows');
    if (el) {
      el.innerHTML = _recapRows().map(function (r) {
        return '<div class="qasm-modal-recap-row"><span>' + _esc(r[0]) + '</span><span>' + _esc(r[1]) + '</span></div>';
      }).join('');
    }
    var priceEl = document.querySelector('.qasm-modal-price-row strong');
    var src = $('qasm-pf-num');
    if (priceEl && src) priceEl.textContent = src.textContent;
  }

  function _buildModalBody() {
    var ta = $('qasm-modal-body');
    if (!ta) return;
    var lines = ['Configurazione Cornice su Misura (da percorso assistito)'];
    _recapRows().forEach(function (r) { lines.push(r[0] + ': ' + r[1]); });
    var res = _calcPrezzo();
    var stima = res
      ? (res.soloPreventivo ? 'Solo su preventivo' : FR.fmtEuro(res.prezzoIva) + ' (spedizione esclusa)')
      : '—';
    lines.push('Stima prezzo: ' + stima);
    ta.value = lines.join('\n');
  }

  function _checkSuccess() {
    var flag = false;
    try { flag = sessionStorage.getItem('qasm_success') === '1'; } catch (e) {}
    if (!flag && /[?&]contact_posted=true/.test(window.location.search)) flag = true;
    if (!flag) return;
    try { sessionStorage.removeItem('qasm_success'); } catch (e) {}
    var banner = $('qasm-success-banner');
    if (banner) { banner.hidden = false; banner.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  /* ══════════════════════════════════════
     UTIL
  ══════════════════════════════════════ */
  function _esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ══════════════════════════════════════
     BOOTSTRAP
  ══════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    function ready() {
      return window.QASM_DATA && window.ASTE_CORNICI_FULL && window.FOTORECORD && window.FOTORECORD.core;
    }
    if (ready()) { init(); return; }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (ready()) { clearInterval(timer); init(); }
      else if (attempts >= 30) {
        clearInterval(timer);
        if (window.QASM_DATA && window.FOTORECORD && window.FOTORECORD.core) { console.warn('[QASM] Avvio con dati parziali'); init(); }
        else console.error('[QASM] QASM_DATA non disponibile — quiz non inizializzato');
      }
    }, 100);
  });

})();
